import { handleActions } from 'redux-actions';

import { types, inputFieldNames } from '../constants';

import { utcToLocal } from './../utils/timeConverter';
import { getUniqueArray } from './../utils/attachmentUtils';

const INITIAL_STATE = {
  newAccident: {
    showCreateAccidentDialog: false,
    showEditAccidentDialog: false,
    item: {
      injuryDate: null,
      injuryLocationId: 0,
      injuryTypeId: 0,
      injuryCauseId: 0,
      personnelId: 0,
      injuryTime: null,
      attachmentFiles: [],
      existingAttachmentFiles: []
    },
    isSaving: false,
    errorMessage: ''
  },
  accident: {
    item: null,
    isLoading: false,
    errorMessage: ''
  },
  deleteOrDeactivatingAccident: {
    open: false,
    isSaving: false,
    accident: null,
    errorMessage: '',
    status: 0,
    item: {}
  }
};

const openCreateAccidentDialog = (state, { open }) => {
  return {
    ...state,
    newAccident: {
      ...state.newAccident,
      showCreateAccidentDialog: open,
      item: {
        injuryDate: null,
        injuryLocationId: 0,
        injuryTypeId: 0,
        injuryCauseId: 0,
        personnelId: 0,
        injuryTime: null
      }
    }
  };
};

const openEditAccidentDialog = (state, { open }) => {
  return {
    ...state,
    newAccident: {
      ...state.newAccident,
      showEditAccidentDialog: open,
      item: {
        injuryDate: null,
        injuryLocationId: 0,
        injuryTypeId: 0,
        injuryCauseId: 0,
        personnelId: 0,
        injuryTime: null
      }
    }
  };
};

const inputChangeCreateAccidentForm = (state, { value, inputFieldName }) => {
  const accident = { ...state.newAccident.item };
  switch (inputFieldName) {
    case inputFieldNames.INJURY_DATE:
      if (accident.injuryTime === null && value !== null) {
        accident.injuryDate = new Date(
          value.get('year'),
          value.get('month'),
          value.get('date')
        );
      } else if (value != null) {
        accident.injuryDate = new Date(
          value.get('year'),
          value.get('month'),
          value.get('date'),
          accident.injuryTime.get('hour'),
          accident.injuryTime.get('minute'),
          accident.injuryTime.get('second')
        );
      } else {
        accident.injuryDate = value;
      }
      break;
    case inputFieldNames.INJURY_TIME:
      if (accident.injuryDate !== null && value !== null) {
        const converted = utcToLocal(accident.injuryDate);
        let date = new Date(
          converted.get('year'),
          converted.get('month'),
          converted.get('date'),
          value.get('hour'),
          value.get('minute'),
          value.get('second')
        );
        accident.injuryDate = date;
        accident.injuryTime = value;
      } else if (accident.injuryDate !== null && value === null) {
        const converted = utcToLocal(accident.injuryDate);
        let date = new Date(
          converted.get('year'),
          converted.get('month'),
          converted.get('date')
        );
        accident.injuryDate = date;
        accident.injuryTime = value;
      } else {
        accident.injuryTime = value;
      }
      break;
    case inputFieldNames.INJURY_LOCATION:
      accident.injuryLocationId = value;
      break;
    case inputFieldNames.INJURY_TYPE:
      accident.injuryTypeId = value;
      break;
    case inputFieldNames.INJURY_CAUSE:
      accident.injuryCauseId = value;
      break;
    case inputFieldNames.PERSONNEL:
      accident.personnelId = value;
      break;
    case inputFieldNames.ACCIDENT_ATTACHMENT:
      if (!accident.attachmentFiles) {
        accident.attachmentFiles = [];
      }
      accident.attachmentFiles.push(value);
      var filteredArray = getUniqueArray(accident.attachmentFiles);
      accident.attachmentFiles = filteredArray;
      break;
    default:
  }

  return {
    ...state,
    newAccident: {
      ...state.newAccident,
      item: accident
    }
  };
};

const checkAndFindInjuryTime = (time) => {
  const convertedTime = utcToLocal(time);

  let secondes = convertedTime.get('second');

  if (secondes > 0) {
    return time;
  } else {
    return null;
  }
};

const editAccident = (state, { accident }) => {
  return {
    ...state,
    newAccident: {
      ...state.newAccident,
      item: {
        ...accident,
        injuryTime: checkAndFindInjuryTime(accident.injuryDate)
      }
    }
  };
};

const showDeleteOrDeactiveAccidentDialog = (
  state,
  { open, accident, status }
) => {
  return {
    ...state,
    deleteOrDeactivatingAccident: {
      ...state.deleteOrDeactivatingAccident,
      open,
      accident,
      status,
      errorMessage: ''
    }
  };
};

const startSubmitAccident = (state) => {
  return {
    ...state,
    newAccident: {
      ...state.newAccident,
      isSaving: true
    }
  };
};

const submitAccidentSuccess = (state, { submittedAccident }) => {
  return {
    ...state,
    accident: {
      ...state.accident,
      item: submittedAccident
    }
  };
};

const submitAccidentFailure = (state, { errorMessage }) => {
  return {
    ...state,
    newAccident: {
      ...state.newAccident,
      errorMessage
    }
  };
};

const submitAccidentFinished = (state) => {
  return {
    ...state,
    newAccident: {
      ...state.newAccident,
      isSaving: false
    }
  };
};

const startDeactivateOrDeleteAccident = (state) => {
  return {
    ...state,
    deleteOrDeactivatingAccident: {
      ...state.deleteOrDeactivatingAccident,
      isSaving: true
    }
  };
};

const deactivateOrDeleteAccidentSuccess = (state) => {
  return {
    ...state
  };
};

const deactivateOrDeleteAccidentFailure = (state, { errorMessage }) => {
  return {
    ...state,
    deleteOrDeactivatingAccident: {
      ...state.deleteOrDeactivatingAccident,
      errorMessage
    }
  };
};

const deactivateOrDeleteAccidentFinished = (state) => {
  return {
    ...state,
    deleteOrDeactivatingAccident: {
      ...state.deleteOrDeactivatingAccident,
      isSaving: false
    }
  };
};

//Attachments
const removeAttachment = (state, { attachment }) => {
  let accident = state.newAccident.item;
  let remainingAttachements = accident.attachmentFiles.filter(
    (item) => item.name !== attachment.name
  );
  accident.attachmentFiles = remainingAttachements;
  return {
    ...state,
    newAccident: {
      ...state.newAccident,
      item: accident
    }
  };
};

const startLoadAttachmentsForAccident = (state) => {
  return {
    ...state,
    newAccident: {
      ...state.newAccident,
      isSaving: true
    }
  };
};

const loadAttachmentsForAccidentSuccess = (state, { attachments }) => {
  var attachmentCustomObjets = [];

  for (let index = 0; index < attachments.length; index++) {
    const element = {
      id: attachments[index].id,
      newlyAdded: false,
      removed: false,
      fileData: null,
      name: attachments[index].fileName,
      url: attachments[index].url
    };
    attachmentCustomObjets.push(element);
  }

  return {
    ...state,
    newAccident: {
      ...state.newAccident,
      item: {
        ...state.newAccident.item,
        attachmentFiles: attachmentCustomObjets,
        existingAttachmentFiles: attachmentCustomObjets
      }
    }
  };
};

const loadAttachmentForAccidentFailure = (state, { errorMessage }) => {
  return {
    ...state,
    newAccident: {
      ...state.newAccident,
      errorMessage
    }
  };
};

const loadAttachmentForAccidentFinished = (state, { errorMessage }) => {
  return {
    ...state,
    newAccident: {
      ...state.newAccident,
      isSaving: false
    }
  };
};

//Handles the incoming actions.
export default handleActions(
  {
    [types.OPEN_CREATE_ACCIDENT_DIALOG]: openCreateAccidentDialog,
    [types.OPEN_EDIT_ACCIDENT_DIALOG]: openEditAccidentDialog,

    [types.INPUT_CHANGE_CREATE_ACCIDENT_FORM]: inputChangeCreateAccidentForm,

    [types.EDIT_ACCIDENT]: editAccident,

    [types.DEACTIVATE_OR_DELETE_ACCIDENT_DIALOG]: showDeleteOrDeactiveAccidentDialog,

    [types.START_SUBMIT_ACCIDENT]: startSubmitAccident,
    [types.SUBMIT_ACCIDENT_SUCCESS]: submitAccidentSuccess,
    [types.SUBMIT_ACCIDENT_FAILURE]: submitAccidentFailure,
    [types.SUBMIT_ACCIDENT_FINISHED]: submitAccidentFinished,

    [types.START_DEACTIVATE_OR_DELETE_ACCIDENT]: startDeactivateOrDeleteAccident,
    [types.DEACTIVATE_OR_DELETE_ACCIDENT_SUCCESS]: deactivateOrDeleteAccidentSuccess,
    [types.DEACTIVATE_OR_DELETE_ACCIDENT_FAILURE]: deactivateOrDeleteAccidentFailure,
    [types.DEACTIVATE_OR_DELETE_ACCIDENT_FINISHED]: deactivateOrDeleteAccidentFinished,

    [types.START_LOAD_ATTACHMENTS_FOR_ACCIDENT]: startLoadAttachmentsForAccident,
    [types.LOAD_ATTACHMENTS_FOR_ACCIDENT_SUCCESS]: loadAttachmentsForAccidentSuccess,
    [types.LOAD_ATTACHMENTS_FOR_ACCIDENT_FAILURE]: loadAttachmentForAccidentFailure,
    [types.LOAD_ATTACHMENTS_FOR_ACCIDENT_FINISHED]: loadAttachmentForAccidentFinished,

    [types.REMOVE_ACCIDENT_ATTACHMENT]: removeAttachment
  },
  INITIAL_STATE
);
